export const FIELDS = [
  {
    NAME: 'name',
    LIMIT: 50,
    IS_REQUIRED: [],
    TYPE: 'basic',
  },
  {
    NAME: 'description',
    LIMIT: 100,
    IS_REQUIRED: [],
    MIN_HEIGHT: 60,
    TYPE: 'basic',
  },
];

export default {
  FIELDS,
};
